'use client';

import React from 'react';

type LoadingIndicatorProps = {
  message?: string;
  compact?: boolean;
}

export function LoadingIndicator({ 
  message = 'Thinking...', 
  compact = false 
}: LoadingIndicatorProps) {
  if (compact) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '8px 12px',
        backgroundColor: 'var(--background-muted)',
        borderRadius: '8px',
        fontSize: '12px',
        color: 'var(--foreground-subtle)'
      }}>
        <div style={{
          display: 'flex',
          gap: '2px'
        }}>
          <div style={{
            width: '4px',
            height: '4px',
            backgroundColor: 'var(--foreground-subtle)',
            borderRadius: '50%',
            animation: 'bounce 1.4s ease-in-out infinite both'
          }} />
          <div style={{
            width: '4px',
            height: '4px',
            backgroundColor: 'var(--foreground-subtle)',
            borderRadius: '50%',
            animation: 'bounce 1.4s ease-in-out 0.16s infinite both'
          }} />
          <div style={{
            width: '4px',
            height: '4px',
            backgroundColor: 'var(--foreground-subtle)',
            borderRadius: '50%',
            animation: 'bounce 1.4s ease-in-out 0.32s infinite both'
          }} />
        </div>
        <span>{message}</span>
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', gap: '12px' }}>
      <div style={{
        width: '28px',
        height: '28px',
        backgroundColor: 'var(--chat-accent)',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0
      }}>
        <span style={{ fontSize: '14px' }}>🤖</span>
      </div>
      <div style={{
        padding: '12px 16px',
        backgroundColor: 'var(--background-muted)',
        borderRadius: '12px',
        display: 'flex',
        alignItems: 'center',
        gap: '8px'
      }}>
        <div style={{
          display: 'flex',
          gap: '4px'
        }}>
          <div style={{
            width: '8px',
            height: '8px',
            backgroundColor: 'var(--foreground-subtle)',
            borderRadius: '50%',
            animation: 'bounce 1.4s ease-in-out infinite both'
          }} />
          <div style={{
            width: '8px',
            height: '8px',
            backgroundColor: 'var(--foreground-subtle)',
            borderRadius: '50%',
            animation: 'bounce 1.4s ease-in-out 0.16s infinite both'
          }} />
          <div style={{
            width: '8px',
            height: '8px',
            backgroundColor: 'var(--foreground-subtle)',
            borderRadius: '50%',
            animation: 'bounce 1.4s ease-in-out 0.32s infinite both'
          }} />
        </div>
        <span style={{
          fontSize: '14px',
          color: 'var(--foreground-subtle)'
        }}>
          {message}
        </span>
      </div>

      <style>{`
        @keyframes bounce {
          0%, 80%, 100% {
            transform: scale(0);
          }
          40% {
            transform: scale(1);
          }
        }
      `}</style>
    </div>
  );
}

